var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.inline)?_c('span',{staticClass:"count-down-timer"},[_vm._v(_vm._s(_vm.countDownDisplay))]):_c('article',{staticClass:"count-down-timer",class:{ 'bloop-animation': _vm.doBloopAnimation }},[_c('p',[_vm._v(_vm._s(_vm.countDownDisplay))])])}
var staticRenderFns = []

export { render, staticRenderFns }